export const byId = (state, payload, idProp = 'id') => {
  return Object.assign({}, state, {
    byId: Object.assign(Object.assign({}, state.byId, {[payload[idProp]]: payload}))
  });
};
